// // src/app/modules/Auth/pages/OrganizationSetup.jsx
// import React, { useState, useEffect } from "react";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import { useDispatch } from "react-redux";
// import { useNavigate, useLocation } from 'react-router-dom';
// import * as auth from "../_redux/authRedux";
// import { createOrganization } from "../_redux/authCrud";
// import './auth.scss';
// import { 
//   Building2, 
//   Mail, 
//   Phone, 
//   MapPin,
//   Home,
//   Briefcase,
//   Calendar,
// } from 'lucide-react';

// const initialValues = {
//   organization_name: "",
//   organization_type: "residential_estate",
//   organization_email: "",
//   organization_phone: "",
//   street: "",
//   city: "",
//   state: "",
// };

// const organizationTypes = [
//   { 
//     value: 'residential_estate', 
//     label: 'Residential Estate',
//     description: 'Gated communities',
//     icon: Home,
//   },
//   { 
//     value: 'commercial_building', 
//     label: 'Commercial Building',
//     description: 'Office buildings',
//     icon: Briefcase,
//   },
//   { 
//     value: 'residential_building', 
//     label: 'Residential Building',
//     description: 'Apartments & condos',
//     icon: Building2,
//   },
//   { 
//     value: 'event_venue', 
//     label: 'Event Venue',
//     description: 'Event & conference',
//     icon: Calendar,
//   },
// ];

// function OrganizationSetup() {
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const location = useLocation();

//   // Get user data from navigation state
//   const { user, fromRegistration } = location.state || {};

// //   useEffect(() => {
// //     // If no user data, redirect to login
// //     if (!user) {
// //       console.log('❌ No user data found, redirecting to login');
// //       navigate('/auth/login');
// //     }
// //   }, [user, navigate]);

//   const OrganizationSchema = Yup.object().shape({
//     organization_name: Yup.string()
//       .min(2, "Organization name must be at least 2 characters")
//       .max(100, "Organization name is too long")
//       .required("Organization name is required"),
//     organization_type: Yup.string()
//       .required("Please select an organization type"),
//     organization_email: Yup.string()
//       .email("Invalid email address")
//       .required("Organization email is required"),
//     organization_phone: Yup.string()
//       .matches(/^[+]?[0-9]{10,15}$/, "Enter a valid phone number")
//       .required("Organization phone is required"),
//     street: Yup.string()
//       .min(3, "Street address is too short")
//       .required("Street address is required"),
//     city: Yup.string()
//       .min(2, "City name is too short")
//       .required("City is required"),
//     state: Yup.string()
//       .min(2, "State name is too short")
//       .required("State is required"),
//   });

//   const formik = useFormik({
//     initialValues,
//     validationSchema: OrganizationSchema,
//     onSubmit: (values, { setStatus, setSubmitting }) => {
//       setLoading(true);
//       setStatus('');
      
//       const payload = {
//         name: values.organization_name,
//         type: values.organization_type,
//         email: values.organization_email,
//         phone_number: values.organization_phone,
//         address: {
//           street: values.street,
//           city: values.city,
//           state: values.state,
//           country: 'Nigeria',
//         },
//       };

//       createOrganization(payload)
//         .then((response) => {
//           setLoading(false);
//           setSubmitting(false);
          
//           // Refresh user data to get the new organization
//           dispatch(auth.actions.requestUser());
          
//           // Navigate to dashboard
//         //   navigate('/dashboard');
//         })
//         .catch((error) => {
//           setLoading(false);
//           setSubmitting(false);
//           const message = error.response?.data?.message || 'An error occurred while creating organization';
//           setStatus(message);
//         });
//     },
//   });

//   const handleSkip = () => {
//     // User can skip and set up organization later
//     navigate(-1);
//   };

//   return (
//     <div className="clean-login-card">
//       <div className="login-header">
//         <h1 className="login-title">
//           {fromRegistration ? 'Welcome' : 'Set Up Your Organization'}{user?.first_name ? `, ${user.first_name}!` : ''}
//         </h1>
//         <p className="login-subtitle">
//           {fromRegistration 
//             ? 'Complete your account setup by adding your organization details'
//             : 'Tell us about your property or facility'
//           }
//         </p>
//       </div>

//       {formik.status && (
//         <div className="login-alert">
//           {formik.status}
//         </div>
//       )}

//       <form onSubmit={formik.handleSubmit} className="login-form">
//         {/* Organization Name */}
//         <div className="form-group">
//           <label className="form-label">Organization Name</label>
//           <div className="input-with-icon">
//             <Building2 size={18} className="input-icon" />
//             <input
//               type="text"
//               name="organization_name"
//               placeholder="Your Company or Property Name"
//               autoComplete="organization"
//               className={`form-control with-icon ${
//                 formik.touched.organization_name && formik.errors.organization_name ? 'error' : ''
//               }`}
//               {...formik.getFieldProps("organization_name")}
//             />
//           </div>
//           {formik.touched.organization_name && formik.errors.organization_name && (
//             <div className="form-error">{formik.errors.organization_name}</div>
//           )}
//         </div>

//         {/* Organization Type - Card Selection */}
//         <div className="form-group">
//           <label className="form-label">Organization Type</label>
//           <p className="form-helper">Select the type that best describes your property</p>
//           <div className="org-type-grid">
//             {organizationTypes.map(type => {
//               const Icon = type.icon;
//               const isSelected = formik.values.organization_type === type.value;
              
//               return (
//                 <div
//                   key={type.value}
//                   className={`org-type-card ${isSelected ? 'selected' : ''}`}
//                   onClick={() => formik.setFieldValue('organization_type', type.value)}
//                 >
//                   <Icon size={24} className="org-type-icon" />
//                   <h4 className="org-type-label">{type.label}</h4>
//                   <p className="org-type-desc">{type.description}</p>
//                 </div>
//               );
//             })}
//           </div>
//           {formik.touched.organization_type && formik.errors.organization_type && (
//             <div className="form-error">{formik.errors.organization_type}</div>
//           )}
//         </div>

//         {/* Organization Contact */}
//         <div className="form-row">
//           <div className="form-group">
//             <label className="form-label">Organization Email</label>
//             <input
//               type="email"
//               name="organization_email"
//               placeholder="info@company.com"
//               autoComplete="email"
//               className={`form-control ${
//                 formik.touched.organization_email && formik.errors.organization_email ? 'error' : ''
//               }`}
//               {...formik.getFieldProps("organization_email")}
//             />
//             {formik.touched.organization_email && formik.errors.organization_email && (
//               <div className="form-error">{formik.errors.organization_email}</div>
//             )}
//           </div>

//           <div className="form-group">
//             <label className="form-label">Organization Phone</label>
//             <input
//               type="tel"
//               name="organization_phone"
//               placeholder="+2348012345678"
//               autoComplete="tel"
//               className={`form-control ${
//                 formik.touched.organization_phone && formik.errors.organization_phone ? 'error' : ''
//               }`}
//               {...formik.getFieldProps("organization_phone")}
//             />
//             {formik.touched.organization_phone && formik.errors.organization_phone && (
//               <div className="form-error">{formik.errors.organization_phone}</div>
//             )}
//           </div>
//         </div>

//         {/* Address */}
//         <div className="form-group">
//           <label className="form-label">Street Address</label>
//           <div className="input-with-icon">
//             <MapPin size={18} className="input-icon" />
//             <input
//               type="text"
//               name="street"
//               placeholder="123 Main Street"
//               autoComplete="street-address"
//               className={`form-control with-icon ${
//                 formik.touched.street && formik.errors.street ? 'error' : ''
//               }`}
//               {...formik.getFieldProps("street")}
//             />
//           </div>
//           {formik.touched.street && formik.errors.street && (
//             <div className="form-error">{formik.errors.street}</div>
//           )}
//         </div>

//         <div className="form-row">
//           <div className="form-group">
//             <label className="form-label">City</label>
//             <input
//               type="text"
//               name="city"
//               placeholder="Lagos"
//               autoComplete="address-level2"
//               className={`form-control ${
//                 formik.touched.city && formik.errors.city ? 'error' : ''
//               }`}
//               {...formik.getFieldProps("city")}
//             />
//             {formik.touched.city && formik.errors.city && (
//               <div className="form-error">{formik.errors.city}</div>
//             )}
//           </div>

//           <div className="form-group">
//             <label className="form-label">State</label>
//             <input
//               type="text"
//               name="state"
//               placeholder="Lagos"
//               autoComplete="address-level1"
//               className={`form-control ${
//                 formik.touched.state && formik.errors.state ? 'error' : ''
//               }`}
//               {...formik.getFieldProps("state")}
//             />
//             {formik.touched.state && formik.errors.state && (
//               <div className="form-error">{formik.errors.state}</div>
//             )}
//           </div>
//         </div>

//         {/* Submit and Skip Buttons */}
//         <div className="form-row form-buttons">
//           <button
//             type="button"
//             onClick={handleSkip}
//             className="back-btn-step"
//             disabled={loading}
//           >
//             Go back
//           </button>
//           <button
//             type="submit"
//             disabled={formik.isSubmitting || loading}
//             className="submit-btn-step"
//           >
//             {loading ? (
//               <>
//                 Creating organization...
//                 <span className="spinner"></span>
//               </>
//             ) : (
//               'Continue'
//             )}
//           </button>
//         </div>

//         <p className="form-hint text-center mt-4">
//           You can set up your organization later from your dashboard settings
//         </p>
//       </form>
//     </div>
//   );
// }

// export default OrganizationSetup;



// src/app/modules/Auth/pages/OrganizationSetup.jsx
import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from 'react-router-dom';
import * as auth from "../_redux/authRedux";
import { createOrganization } from "../_redux/authCrud";
import AddressAutocomplete from '../components/AddressAutocomplete';
import './auth.scss';
import {
  Building2,
  Building,
  Home,
  Briefcase,
  Calendar,
} from 'lucide-react';

// Common countries list — ISO 3166-1 alpha-2
const COUNTRIES = [
  { code: 'NG', name: 'Nigeria' },
  { code: 'US', name: 'United States' },
  { code: 'GB', name: 'United Kingdom' },
  { code: 'KE', name: 'Kenya' },
  { code: 'GH', name: 'Ghana' },
  { code: 'ZA', name: 'South Africa' },
  { code: 'ET', name: 'Ethiopia' },
  { code: 'TZ', name: 'Tanzania' },
  { code: 'UG', name: 'Uganda' },
  { code: 'RW', name: 'Rwanda' },
  { code: 'SN', name: 'Senegal' },
  { code: 'CI', name: "Côte d'Ivoire" },
  { code: 'CM', name: 'Cameroon' },
  { code: 'EG', name: 'Egypt' },
  { code: 'MA', name: 'Morocco' },
  { code: 'CA', name: 'Canada' },
  { code: 'AU', name: 'Australia' },
  { code: 'DE', name: 'Germany' },
  { code: 'FR', name: 'France' },
  { code: 'AE', name: 'United Arab Emirates' },
  { code: 'SA', name: 'Saudi Arabia' },
  { code: 'IN', name: 'India' },
  { code: 'BR', name: 'Brazil' },
  { code: 'SG', name: 'Singapore' },
  { code: 'ZM', name: 'Zambia' },
  { code: 'ZW', name: 'Zimbabwe' },
].sort((a, b) => a.name.localeCompare(b.name));

const initialValues = {
  organization_name: "",
  organization_type: "residential_estate",
  organization_email: "",
  organization_phone: "",
  country_code: "",
  street: "",
  city: "",
  state: "",
};

const organizationTypes = [
  { 
    value: 'residential_estate', 
    label: 'Residential Estate',
    description: 'Gated communities',
    icon: Home,
  },
  { 
    value: 'office_building', // New entry added second
    label: 'Office Building',
    description: 'Corporate workspaces',
    icon: Building, 
  },
  { 
    value: 'commercial_building', 
    label: 'Commercial Building',
    description: 'Office buildings',
    icon: Briefcase,
  },
  { 
    value: 'residential_building', 
    label: 'Residential Building',
    description: 'Apartments & condos',
    icon: Building2,
  },
  { 
    value: 'event_venue', 
    label: 'Event Venue',
    description: 'Event & conference',
    icon: Calendar,
  },
];

function OrganizationSetup() {
  const [loading, setLoading] = useState(false);
  const [coordinates, setCoordinates] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  // Get user data from navigation state
  const { user, fromRegistration } = location.state || {};

  const OrganizationSchema = Yup.object().shape({
    organization_name: Yup.string()
      .min(2, "Organization name must be at least 2 characters")
      .max(100, "Organization name is too long")
      .required("Organization name is required"),
    organization_type: Yup.string()
      .required("Please select an organization type"),
    organization_email: Yup.string()
      .email("Invalid email address")
      .required("Organization email is required"),
    organization_phone: Yup.string()
      .matches(/^[+]?[0-9]{6,15}$/, "Enter a valid phone number with country code")
      .required("Organization phone is required"),
    country_code: Yup.string()
      .length(2, "Select a country")
      .required("Country is required"),
    street: Yup.string()
      .min(3, "Street address is too short")
      .required("Street address is required"),
    city: Yup.string()
      .min(2, "City name is too short")
      .required("City is required"),
    state: Yup.string()
      .min(2, "State name is too short")
      .required("State is required"),
  });

  const formik = useFormik({
    initialValues,
    validationSchema: OrganizationSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      // Check if coordinates are available
      if (!coordinates) {
        setStatus('Please select a valid address from the suggestions or ensure your address can be found on the map.');
        setSubmitting(false);
        return;
      }

      setLoading(true);
      setStatus('');

      const selectedCountry = COUNTRIES.find(c => c.code === values.country_code);

      const payload = {
        name:         values.organization_name,
        type:         values.organization_type,
        email:        values.organization_email,
        phone_number: values.organization_phone,
        country_code: values.country_code,
        address: {
          street:  values.street,
          city:    values.city,
          state:   values.state,
          country: selectedCountry?.name || values.country_code,
          coordinates: [coordinates.lon, coordinates.lat],
        },
      };

      createOrganization(payload)
        .then(() => {
          setLoading(false);
          setSubmitting(false);
          dispatch(auth.actions.requestUser());
          navigate('/dashboard');
        })
        .catch((error) => {
          setLoading(false);
          setSubmitting(false);
          setStatus(error.response?.data?.message || 'An error occurred while creating organization');
        });
    },
  });

  const handleAddressSelect = (addressData) => {
    if (!addressData || !addressData.coordinates) {
      setCoordinates(null);
      return;
    }
    setCoordinates(addressData.coordinates);
  };

  const handleSkip = () => {
    // User can skip and set up organization later
    navigate(-1);
  };

  return (
    <div className="clean-login-card">
      <div className="login-header">
        <h1 className="login-title">
          {fromRegistration ? 'Welcome' : 'Set Up Your Organization'}{user?.first_name ? `, ${user.first_name}!` : ''}
        </h1>
        <p className="login-subtitle">
          {fromRegistration 
            ? 'Complete your account setup by adding your organization details'
            : 'Tell us about your property or facility'
          }
        </p>
      </div>

      {formik.status && (
        <div className="login-alert">
          {formik.status}
        </div>
      )}

      <form onSubmit={formik.handleSubmit} className="login-form">
        {/* Organization Name */}
        <div className="form-group">
          <label className="form-label">Organization Name</label>
          <div className="input-with-icon">
            <Building2 size={18} className="input-icon" />
            <input
              type="text"
              name="organization_name"
              placeholder="Your Company or Property Name"
              autoComplete="organization"
              className={`form-control with-icon ${
                formik.touched.organization_name && formik.errors.organization_name ? 'error' : ''
              }`}
              {...formik.getFieldProps("organization_name")}
            />
          </div>
          {formik.touched.organization_name && formik.errors.organization_name && (
            <div className="form-error">{formik.errors.organization_name}</div>
          )}
        </div>

        {/* Organization Type - Card Selection */}
        <div className="form-group">
          <label className="form-label">Organization Type</label>
          <p className="form-helper">Select the type that best describes your property</p>
          <div className="org-type-grid">
            {organizationTypes.map(type => {
              const Icon = type.icon;
              const isSelected = formik.values.organization_type === type.value;
              
              return (
                <div
                  key={type.value}
                  className={`org-type-card ${isSelected ? 'selected' : ''}`}
                  onClick={() => formik.setFieldValue('organization_type', type.value)}
                >
                  <Icon size={24} className="org-type-icon" />
                  <h4 className="org-type-label">{type.label}</h4>
                  <p className="org-type-desc">{type.description}</p>
                </div>
              );
            })}
          </div>
          {formik.touched.organization_type && formik.errors.organization_type && (
            <div className="form-error">{formik.errors.organization_type}</div>
          )}
        </div>

        {/* Organization Contact */}
        <div className="form-row">
          <div className="form-group">
            <label className="form-label">Organization Email</label>
            <input
              type="email"
              name="organization_email"
              placeholder="info@company.com"
              autoComplete="email"
              className={`form-control ${
                formik.touched.organization_email && formik.errors.organization_email ? 'error' : ''
              }`}
              {...formik.getFieldProps("organization_email")}
            />
            {formik.touched.organization_email && formik.errors.organization_email && (
              <div className="form-error">{formik.errors.organization_email}</div>
            )}
          </div>

          <div className="form-group">
            <label className="form-label">Organization Phone</label>
            <input
              type="tel"
              name="organization_phone"
              placeholder="+2348012345678"
              autoComplete="tel"
              className={`form-control ${
                formik.touched.organization_phone && formik.errors.organization_phone ? 'error' : ''
              }`}
              {...formik.getFieldProps("organization_phone")}
            />
            {formik.touched.organization_phone && formik.errors.organization_phone && (
              <div className="form-error">{formik.errors.organization_phone}</div>
            )}
          </div>
        </div>

        {/* Country */}
        <div className="form-group">
          <label className="form-label">Country</label>
          <select
            name="country_code"
            className={`form-control ${formik.touched.country_code && formik.errors.country_code ? 'error' : ''}`}
            {...formik.getFieldProps("country_code")}
          >
            <option value="">Select country…</option>
            {COUNTRIES.map(c => (
              <option key={c.code} value={c.code}>{c.name}</option>
            ))}
          </select>
          {formik.touched.country_code && formik.errors.country_code && (
            <div className="form-error">{formik.errors.country_code}</div>
          )}
        </div>

        {/* Address with Autocomplete */}
        <div className="form-group">
          <label className="form-label">Organization Address</label>
          <p className="form-helper">Search for your address or enter it manually</p>
          <AddressAutocomplete
            formik={formik}
            onAddressSelect={handleAddressSelect}
            placeholder="Start typing your address..."
            countryCode={formik.values.country_code ? formik.values.country_code.toLowerCase() : undefined}
          />
        </div>

        {/* Show coordinates if found */}
        {coordinates && (
          <div className="coordinates-info success">
            {/* <small>
              ✅ Location verified: {coordinates.lat.toFixed(6)}, {coordinates.lon.toFixed(6)}
            </small> */}
          </div>
        )}

        {/* Show warning if no coordinates */}
        {!coordinates && (formik.touched.street || formik.touched.city) && (
          <div className="coordinates-info warning">
            <small>
              ⚠️ Address not verified. Please select from suggestions or ensure your address is correct.
            </small>
          </div>
        )}

        {/* Submit and Skip Buttons */}
        <div className="form-row form-buttons">
          <button
            type="button"
            onClick={handleSkip}
            className="back-btn-step"
            disabled={loading}
          >
            Go back
          </button>
          <button
            type="submit"
            disabled={formik.isSubmitting || loading}
            className="submit-btn-step"
          >
            {loading ? (
              <>
                Creating organization...
                <span className="spinner"></span>
              </>
            ) : (
              'Continue'
            )}
          </button>
        </div>

        <p className="form-hint text-center mt-4">
          You can set up your organization later from your dashboard settings
        </p>
      </form>
    </div>
  );
}

export default OrganizationSetup;